import Vue from 'vue'
import stylesMixin from '@/mixins/styles-mixin.js'
import authMixin from '@/mixins/auth-mixin.js'
import userRightsMixin from '@/mixins/rights-mixin.js'
import geocodingMixin from '@/components/shared/geocoding/geocoding-mixin.js'
import iconsMixins from '@/mixins/icons-mixin.js'
Vue.use({
  install() {
    Vue.$mixins = Vue.prototype.$mixins = {
      userRightsMixin,
      stylesMixin,
      authMixin,
      geocodingMixin,
      iconsMixins,
    }
  },
})
